import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  routePrefix = "/api/otp";
  constructor(private http: HttpClient) { }

  otpSessionCancel(securityToken: any): Observable<any> {
    const data = { securityToken: securityToken }
    sessionStorage.removeItem('requestToken');
    return this.http.post(this.routePrefix + "/otpSessionCancel", data);
  }

  otpValidation(data: any) {
    return this.http.post(`${this.routePrefix}/otp-validation`, data);
  }

  generateOtp(data:any) {
    return this.http.post(`${this.routePrefix}/generate-otp-code`, data);
  }
}
